<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12">
                                <div class="pull-left">
                                    <h4 class="card-title float-left" v-if="action === 'edit'">
                                        {{$t('client.add.titlePhysical')}}</h4>
                                    <h4 class="card-title float-left" v-else-if="action === 'view'">
                                        {{$t('client.titleAddEditPhysical')}}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.username')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.username">
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.lastName')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.lastname">
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.firstName')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.firstname">
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.midName')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.midname">
                                </div>
                                <div class="form-group">
                                    <label>{{$t('accounting.account.identificationNumber')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.identificationNumber">
                                </div>
                                <div class="form-group">
                                    <label>{{$t('accounting.account.pinflNumber')}} <span class="red">*</span></label>
                                    <pinfl-input
                                        :pinfl.sync="employeeData.pinflNumber"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.phone')}} <span class="red">*</span></label>
                                    <the-mask type="text" class="form-control"
                                              v-model="employeeData.mobilePhone"
                                              mask="+(998) ##-###-####" placeholder="+998 (XX) XXX XXXX"
                                              masked="masked"
                                    >
                                    </the-mask>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.province')}} <span class="red">*</span></label>
                                    <v-select
                                            label="name"
                                            v-model="employeeData.province"
                                            :filterable="false"
                                            :options="provinces"
                                            @search="onProvinceSearch"
                                            @search:focus="onProvinceFocus"
                                            @change="onProvinceChange"
                                    >
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.region')}} <span class="red">*</span></label>
                                    <v-select
                                            label="name"
                                            v-model="employeeData.region"
                                            :filterable="false"
                                            :options="regions"
                                            @search="onRegionSearch"
                                            @search:focus="onRegionFocus"
                                            @change="onProvinceChange"
                                    >
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.address')}} <span class="red">*</span></label>
                                    <textarea type="text" class="form-control"
                                              v-model="employeeData.address"></textarea>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.regionalLeaderProvince')}} <span class="red">*</span></label>
                                    <v-select
                                            label="name"
                                            v-model="employeeData.province"
                                            :filterable="false"
                                            :options="provinces"
                                            @search="onProvinceSearch"
                                            @search:focus="onProvinceFocus"
                                            @change="onProvinceChange"
                                    >
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.regionalLeaderRegion')}} <span
                                            class="red">*</span></label>
                                    <v-select
                                            label="name"
                                            v-model="employeeData.region"
                                            :filterable="false"
                                            :options="regions"
                                            @search="onRegionSearch"
                                            @search:focus="onRegionFocus"
                                    >
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.regionalLeader')}} <span class="red">*</span></label>
                                    <v-select
                                            label="name"
                                            v-model="employeeData.province"
                                            :filterable="false"
                                            :options="provinces"
                                            @search="onProvinceSearch"
                                            @search:focus="onProvinceFocus"
                                            @change="onProvinceChange"
                                    >
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="checkbox-form">
                                    <div class="answers" v-for="role in roleList" :key="role.id">
                                        <label v-if="role.id==5" class="form-check-label">
                                            <input type="checkbox" v-model="employeeData.roleIds"
                                                   class="form-check-input"
                                                   :value="role.id">
                                            {{role.displayName}}
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.email')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.email">
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.passportNumber')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.passportNumber">
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.passportDate')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.passportDate">
                                </div>

                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.passportGivePlace')}} <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.passportGivePlace">
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.plasticCardNumber')}} <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.plasticCardNumber">
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.plasticCardValidTo')}} <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.plasticCardValidTo">
                                </div>
                                <div class="form-group">
                                    <label>{{$t('appraiserHelpers.accountNumber')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="employeeData.accountNumber">
                                </div>

                                <drop-zone code="passportFiles"
                                           label="appraiserHelpers.passportFiles"
                                           view="XL"
                                           folder="Agent"
                                           subFolder="UserPassport"
                                           :addRemoveLinks="hasCreate"
                                           :editable="hasCreate"
                                           :data="employeeData.passportFiles"
                                           @change="(files) => {employeeData.companyCertificateFiles = files[0]}"
                                           :maxFiles="1"
                                           acceptedFiles="image/*"
                                ></drop-zone>

                                <drop-zone code="diplomaFiles"
                                           label="appraiserHelpers.diplomaFiles"
                                           view="XL"
                                           folder="Agent"
                                           subFolder="UserDiploma"
                                           :addRemoveLinks="hasCreate"
                                           :editable="hasCreate"
                                           :data="employeeData.diplomaFiles"
                                           @change="(files) => {employeeData.diplomaFiles = files[0]}"
                                           :maxFiles="1"
                                           acceptedFiles="image/*"
                                ></drop-zone>

                            </div>
                        </div>
                        <p style="color: black;">Иш берувчининг топшириғи бўйича баҳоловчи ёрдамчиси томонидан ишларни
                            бажариш (хизматлар кўрсатиш) бўйича МЕҲНАТ БИТИМИ</p>
                        <hr>
                        <div class="row">

                            <div class="col-12 col-md-6">
                                <div class="row mt-2 ml-1">
                                    <iframe id="invoiceFrame" frameborder="0" width="800px" height="1024px"></iframe>
                                </div>
                            </div>
                            <div class="col-12 col-md-6" v-if="action!== 'view'">

                                <div class="font-md" style="padding-top: 5px !important;">
                                    <h3 class="bold-text">Баҳоловчи ёрдамчиси имзолаган (ЭЦП): <b>{{new
                                        Date(employeeData.registeredUserEsp ? employeeData.registeredUserEsp.createDate
                                        : '') | dateFormat('DD/MM/YYYY HH:mm')}}</b></h3>
                                    <h5 v-if="employeeData.registeredUserEsp && employeeData.registeredUserEsp.fileFullPath">
                                        <a :href='employeeData.registeredUserEsp.fileFullPath'>
                                            {{employeeData.registeredUserEsp.fileFullPath}}
                                        </a>
                                    </h5>
                                </div>
                                <div class="font-md" style="padding-top: 5px !important;">
                                    <h3 class="bold-text">Директор имзолаган (ЭЦП): <b
                                            v-if="employeeData.directorSignRegisteredUser">{{new
                                        Date(employeeData.directorSignRegisteredUser.createDate) |
                                        dateFormat('DD/MM/YYYY HH:mm')}}</b></h3>
                                    <h5 v-if="employeeData.directorSignRegisteredUser && employeeData.directorSignRegisteredUser.fileFullPath">
                                        <a :href='employeeData.directorSignRegisteredUser.fileFullPath'>
                                            {{employeeData.directorSignRegisteredUser.fileFullPath}}
                                        </a>
                                    </h5>
                                </div>

                                <div class="btns-box" v-if="employeeData.directorSignRegisteredUser == null">
                                    <button class="all-btn  btn-primary" v-if="hasPermission('V2_APPRAISER_HELPER_RECRUIT')" @click="signDirectorInvoice"
                                            :disabled="processing">
                                        Баҳоловчи ёрдамчисини ишга кабул килиш
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import DropZone from '@/views/dropZone/DropZone'
    import PinflInput from "@/components/PinflInput.vue";

    export default {
        components: {
            DropZone,
            PinflInput
        },
        data() {
            return {
                processing: false,
                filter: initFilterModel(),
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                action: 'edit',
                employeeData: {},
                espFileDto: {},
                provinces: [],
                regions: [],
                roleList: [],
                keyOwn: '',
                keyOwnR: '',
                color: '',
                items: [],
                type: '',
                contractEspData: {
                    userId: this.$route.params.id,
                    pkcs7: '',
                    comment: '',
                    textForSign: '',
                    keyId: ''

                }
            }
        },
        computed: {
            hasCreate() {
                return this.$route.query.isCreate != null
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (this.$route && this.$route.params && this.$route.params.action && this.$route.params.action.length > 0) {
                    vm.action = this.$route.params.action;
                }

                if (id != null) {
                    this.$http.get(`/user/${id}`)
                        .then(res => {
                            if (res && res.data && res.data.status !== 'SUCCESS') {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.common.error'),
                                    type: 'error'
                                });
                            } else {
                                this.employeeData = res.data.data;
                                vm.showContractPdf(vm.employeeData.hashUuid);
                                this.initProvince();
                            }
                        }, err => {
                            console.log(err)
                        })
                }
            },
            showContractPdf(id) {
                this.$http.get('/user/appraiser-helper-contract/' + id)
                    .then(response => {
                        let blob = this.convertBase64ToBlob(response.data.fileBase64);
                        this.contractEspData.textForSign = response.data.fileBase64;
                        let encodedString = URL.createObjectURL(blob);
                        let iFrame = document.getElementById("invoiceFrame");
                        iFrame.src = encodedString;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            convertBase64ToBlob(fileBase64) {
                const parts = fileBase64.split(';base64,');
                const imageType = parts[0].split(':')[1];
                const decodedData = window.atob(parts[1]);
                const uInt8Array = new Uint8Array(decodedData.length);
                for (let i = 0; i < decodedData.length; ++i) {
                    uInt8Array[i] = decodedData.charCodeAt(i);
                }
                return new Blob([uInt8Array], {type: imageType});
            },
            onChange() {
                this.$emit('input', this.checked);
            },
            cancel() {
                this.$router.push('/company/appraiser-helper/list')
            },
            initProvince() {
                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                    vm.getProvinceGetRegions();
                });
            },
            getProvinceGetRegions() {
                if (this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.employeeData.provinceId) {
                            this.employeeData.province = province;
                            this.regions = province.regions;
                            province.regions.forEach((region) => {
                                if (region.id === this.employeeData.regionId) {
                                    this.employeeData.region = region;
                                }
                            });
                        }
                    });
                }

            },
            onProvinceChange() {

            },
            onProvinceFocus() {
                this.provinces = [];
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
                this.regions = [];
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            getUserByRole() {
                this.$http.get('/user/role/list')
                    .then(res => {
                        this.roleList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },

            signDirectorInvoice() {
                this.$http.get('esign/user-director/contract/' + this.employeeData.id)
                    .then(res => {
                        this.processing = false;
                        console.log(res.data);
                        window.open(res.data.data, '_blank')
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });

            }
        },
        created() {
            this.init();
            this.getUserByRole();

        }
    }
</script>
<style scoped>

</style>